import { createUpdateSyncSlice } from '@sonar-software/xuder';
import { defaultUserIdMapState } from './state';
import { UpdateUserReferenceRequest, UserReference } from '../../../@types';

export const coreUsersIdMapSlice = createUpdateSyncSlice({
	name: 'CoreUsersIdMap',
	state: defaultUserIdMapState,
	transform: (action: Array<UpdateUserReferenceRequest>, state = {}) => {
		if (!action.length) {
			return state;
		}

		const updatedState: typeof state = {
			...state
		};

		for (const entry of action) {
			const existingEntry = state[ entry.userId ] ?? {};

			if (
				existingEntry.profilePicture &&
				entry.profilePicture &&
				existingEntry.profilePicture !== entry.profilePicture
			) {
				URL.revokeObjectURL(existingEntry.profilePicture);
			}

			const updatedEntry: UserReference = {
				...existingEntry,
				...entry
			};

			updatedEntry.fullName = `${updatedEntry.firstName} ${updatedEntry.lastName}`;

			updatedState[ entry.userId ] = updatedEntry;
		}

		return updatedState;
	}
});
